import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import koKR from 'antd/locale/ko_KR';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import Layout from './components/Layout/Layout';

dayjs.locale('ko');

const queryClient = new QueryClient();

function App() {
    return (
        <HelmetProvider>
            <QueryClientProvider client={queryClient}>
                <ConfigProvider
                    locale={koKR}
                    theme={{
                        token: {
                            colorPrimary: '#2e5bff',
                            colorBgLayout: '#ffffff',
                            borderRadius: 8,
                            fontFamily:
                                'Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, sans-serif',
                        },
                    }}
                >
                    <Layout />
                </ConfigProvider>
            </QueryClientProvider>
        </HelmetProvider>
    );
}

export default App;
